var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcnFatture = function SvgIcnFatture(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.988 20.438",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-80 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(80 17.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M92.263,67.075H82.725A2.728,2.728,0,0,1,80,64.35V50.725A2.728,2.728,0,0,1,82.725,48h1.363v1.363H82.725a1.364,1.364,0,0,0-1.363,1.363V64.35a1.364,1.364,0,0,0,1.363,1.363h9.538a1.364,1.364,0,0,0,1.363-1.363V50.725a1.364,1.364,0,0,0-1.363-1.363H90.9V48h1.363a2.728,2.728,0,0,1,2.725,2.725V64.35A2.728,2.728,0,0,1,92.263,67.075Z",
    transform: "translate(-80 -48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(83.406 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M166.381,20.088h-4.587A1.8,1.8,0,0,1,160,18.294v-.5A1.8,1.8,0,0,1,161.794,16h4.587a1.8,1.8,0,0,1,1.794,1.794v.5A1.8,1.8,0,0,1,166.381,20.088Zm-4.587-2.725a.432.432,0,0,0-.431.431v.5a.432.432,0,0,0,.431.431h4.587a.432.432,0,0,0,.431-.431v-.5a.432.432,0,0,0-.431-.431Z",
    transform: "translate(-160 -16)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFatture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_fatture.3beb165f.svg";
export { ForwardRef as ReactComponent };